import { importMap } from './language-to-translation-map';

export async function getMessagesForLanguage(language: string) {
  let baseLocale: Record<string, string>;

  baseLocale = await importMap[language]();

  return { ...(baseLocale || {}) };
}
